import Box from '@mui/material/Box'
import { FC } from 'react'
import Dislike from '../../../../../assets/icons/Dislike.svg?react'
import Like from '../../../../../assets/icons/Like.svg?react'
import { Notistack } from '../../../../../components/Notistack'
import { useRequestsStore } from '../../../../../store/storeRequests'
import { RatedButton } from './ScoreRating.styles'

type ScoreRating = {
    replyId: number | null
    score?: number | null
}

export const ScoreRating: FC<ScoreRating> = ({ replyId, score }) => {
    const hasScore = Boolean(score)
    const { createRateReply, isLoadingCreateRateReply, errorCreateRateReply } = useRequestsStore()
    const isSnackbarOpen = Boolean(errorCreateRateReply)

    const handleChangeRate = (value: number) => {
        if (replyId) {
            createRateReply({ replyId }, { score: value })
        }
    }

    const handleCloseSnackbar = () => {
        useRequestsStore.setState({ errorCreateRateReply: undefined })
    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    gap: 1,
                }}>
                <RatedButton
                    disabled={hasScore || isLoadingCreateRateReply}
                    selected={hasScore && score >= 3}
                    selectedColor="#019555"
                    onClick={() => handleChangeRate(5)}>
                    <Like />
                </RatedButton>
                <RatedButton
                    disabled={hasScore || isLoadingCreateRateReply}
                    selected={hasScore && score < 3}
                    selectedColor="#CA1616"
                    onClick={() => handleChangeRate(1)}>
                    <Dislike />
                </RatedButton>
            </Box>
            <Notistack
                isError={true}
                open={isSnackbarOpen}
                message={errorCreateRateReply}
                onClose={handleCloseSnackbar}
            />
        </>
    )
}
